import { render, staticRenderFns } from "./DataManage.vue?vue&type=template&id=3e3e4b06&scoped=true"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"
import style0 from "./DataManage.vue?vue&type=style&index=0&id=3e3e4b06&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e4b06",
  null
  
)

export default component.exports